import FontBody2 from '../fonts/font-body2/font-body2';
import {FONT_COLOR, FONT_VARIANT} from '../fonts/font-props';
import IconInfo from '../icons/icon-info/icon-info';
import Icon from '../icons/icon/icon';
import {Tooltip} from '../tooltip/tooltip';
import './form-field-info.scss';

interface IFormFieldInfoProps {
    label: React.ReactNode;
    children: React.ReactNode;
    tooltip?: React.ReactNode;
}

export const FormFieldInfo: React.FC<IFormFieldInfoProps> = ({ label, children, tooltip }) => {
    return (
        <div className="form-field-info">
            <div className="form-field-info-title">
                <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                    {label}
                </FontBody2>
                {tooltip && <Tooltip content={tooltip}><Icon Component={IconInfo} /></Tooltip>}
            </div>
            <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                {children }
            </FontBody2>
        </div>
    );
}

